/* eslint-disable quotes */
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

export const defaultLanguage = "en";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend)
  .init({
    debug: process.env.NODE_ENV === "development",
    fallbackLng: defaultLanguage,
    backend: {
      loadPath: process.env.PUBLIC_URL + `/locales/{{lng}}/{{ns}}.json`,
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;
